import LocationPageTemplate from '../LocationPageTemplate';
import { locationFaqs } from '../../../mocks/faqs';

export default function TarponSpringsPage() {
  return (
    <LocationPageTemplate
      city="Tarpon Springs"
      heroImage="https://www.parksidepavers.com/files/projects/17/images/thumb/thumb_large_IMG%5F0274%2EJPG"
      description="Quality paver installation in Tarpon Springs, FL — custom walkways, patios, driveways, and hardscape solutions for Tarpon Springs area homeowners."
      geoDescription="Parkside Pavers serves Tarpon Springs and surrounding communities with premium paver installation services. Custom patios, driveway pavers, and outdoor living spaces designed for Tarpon Springs properties and local climate conditions."
      mapEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55789.12345678!2d-82.7560!3d28.1506!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2d3a99999999%3A0x0!2sTarpon%20Springs%2C%20FL!5e0!3m2!1sen!2sus!4v1699000000000!5m2!1sen!2sus"
      faqs={locationFaqs['tarpon-springs']}
    />
  );
}
